import { useRouter } from "next/router";
import Footer from "./Footer";
import Header from "./Header";
import DashboardHeader from "./DashboardHeader";
import DashboardSidebar from "./DashboardSidebar";
// import AuthWrapper from "../../../NIB/job-locator-client/hoc/authWrapper";
// import WithAuthWrapper from "../../../NIB/job-locator-client/hoc/withAuthWrapper";
import { ToastContainer } from "react-toastify";

const StoreLayout = ({ children }) => {
  const router = useRouter();
  
  return (
    <div>
      {router.asPath.includes("dashboard") ? (
        <div>
          <div className="flex">
            <div className="">
              <DashboardSidebar />
            </div>
            <div
              className={`w-full min-h-screen ${
                router.asPath == "/dashboard/settings" && "!bg-backgroundColor"
              } `}
            >
              <DashboardHeader />
              <div
                className={`w-full ${
                  router.asPath !== "/dashboard/settings" ? "px-5 py-4 min-h-screen overflow-hidden " : ""
                } ${
                  router.asPath === "/dashboard/keyword-planner"
                    ? "!bg-white"
                    : "!bg-backgroundColor"
                } ${
                  router.asPath === "/dashboard/ai-analyze"
                    ? "!bg-white"
                    : "!bg-backgroundColor"
                } 
                 ${
                  router.asPath.includes('/dashboard/ai-analyze?id=')
                    ? "!bg-white"
                    : "!bg-backgroundColor"
                }
                ${
                  router.asPath === "/dashboard/backlinks"
                    ? "!bg-white"
                    : "!bg-backgroundColor"
                }`}
              >
                {children}
              </div>
              <ToastContainer />
            </div>
          </div>
        </div>
      ) : router.asPath.includes("live-project") ? (
        <div>
          <div className="">{children}</div>
          <ToastContainer />
        </div>
      ) : router.asPath.includes("sign-in") || router.asPath.includes("sign-up") ? (
        <div>
          <div className="">{children}</div>
          <ToastContainer />
        </div>
      ) : (
        <div>
          <Header />
          <div className="">{children}</div>
          {!!!router.asPath.includes("payment-cancel") &&
          !!!router.asPath.includes("payment-success") &&
          !!!router.asPath.includes("forgot-password") &&
          !!!router.asPath.includes("forgot-email") &&
          !!!router.asPath.includes("send-email") &&
          !!!router.asPath.includes("set-password") &&
          !!!router.asPath.includes("confirm-password") ? (
            <Footer />
          ) : null}
          <ToastContainer />
        </div>
      )}
    </div>
  );
};
export default StoreLayout;
